import { FC } from 'react'
import { IconButton, List, ListItem, ListItemText, ListSubheader } from '@material-ui/core'
import { NavigateNext } from '@material-ui/icons'
import { wikiCategoryStyle } from './WikiCategory.style'
import { useDispatch, useSelector } from 'react-redux'
import { wikiActions } from 'src/actions/WikiActions'
import { WikiDocumentMeta } from 'src/dataSources/wiki/Wiki'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { RootState } from 'src/Store'

/**
 * WikiCategoryComponentProps contains properties for the component.
 */
export interface WikiCategoryComponentProps {
  enableBackNavigation: boolean
  onBackPress: () => void
}

/**
 * WikiCategoryComponent displays wiki document in a category
 * @param props Properties for component.
 * @returns JSX component.
 */
export const WikiCategoryComponent: FC<WikiCategoryComponentProps> = (props: WikiCategoryComponentProps) => {
  const classes = wikiCategoryStyle()
  const dispatch = useDispatch()

  const category = useSelector((state: RootState): string => state.wikiState.category)
  const documentsMeta = useSelector((state: RootState): WikiDocumentMeta[] => state.wikiState.documentsMeta)

  return (
    <>
      <List
        component='nav'
        className={classes.list}
        aria-labelledby='nested-list-subheader'
        subheader={
          <ListSubheader component='div' className={`${classes.nestedListSubheader} ${props.enableBackNavigation ? classes.backButtonPadding : ''}`} id='nested-list-subheader'>
            {props.enableBackNavigation && (
              <div className={classes.backButton}>
                <IconButton size='medium' className={classes.backButtonIcon} onClick={props.onBackPress}>
                  <ArrowBackIosIcon />
                </IconButton>
              </div>
            )}
            {category}
          </ListSubheader>
        }
      />
      {documentsMeta
        .filter(document => document.categories.includes(category))
        .map((document, index) => {
          return (
            <div key={index}>
              {index > 0 && (
                <div className={classes.divider} />
              )}
              <ListItem
                button
                className={classes.documentItem}
                onClick={() => dispatch(wikiActions.fetchDocument(document.key))}
              >
                <ListItemText primary={document.title} className={classes.documentItem} />
                <NavigateNext />
              </ListItem>
            </div>
          )
        })}
    </>
  )
}

export default WikiCategoryComponent
